/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PlanDto } from '../models/plan-dto';

@Injectable({
  providedIn: 'root',
})
export class PlanService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation loadPlans
   */
  static readonly LoadPlansPath = '/plans';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadPlans()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadPlans$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PlanDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PlanService.LoadPlansPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PlanDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadPlans$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadPlans(params?: {
  }): Observable<Array<PlanDto>> {

    return this.loadPlans$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PlanDto>>) => r.body as Array<PlanDto>)
    );
  }

}
